// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

@media (height < 700px) {
  app-burger-btn {
    margin-right: 10px;
  }
}

.wrapper {
  position: relative;
  min-height: 56px;
  background: var(--ion-color-tertiary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  width: 100%;
  --icon-color: #1e1e1c;
}
.wrapper .corner {
  position: absolute;
  top: 0;
  left: 0;
  height: 37px;
  width: 49px;
}
.wrapper .left_slot {
  display: flex;
  align-items: center;
}
.wrapper .left_slot .title {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  text-align: left;
  color: var(--color-white);
  width: var(--title-width, 180px);
  margin-left: 9px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 991px) {
  .wrapper .left_slot .title {
    width: 220px;
  }
}
@media (min-width: 991px) {
  .wrapper .change-language {
    margin-left: 30px;
    margin-right: 10px;
  }
}
.wrapper .change-language ion-icon {
  height: 31px;
  width: 31px;
  border-radius: 50%;
  border: 2px solid white;
  margin-right: 20px;
}
.wrapper .wrapper-icons {
  display: flex;
  align-items: center;
}
.wrapper .wrapper-icons ion-icon {
  margin-left: 10px;
}

.back-button {
  margin-left: 10px;
  padding: 3px;
  height: 24px;
  width: 24px;
}

.cross-button {
  margin-right: 22px;
  --ion-icon: #fff;
}

.logo {
  width: 50px;
  height: 50px;
  margin-left: 16px;
  z-index: 1;
}

.order-chip {
  display: none;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-right: 12px;
  margin-left: 10px;
  position: relative;
}
@media (min-width: 991px) {
  .order-chip {
    display: flex;
  }
}
.order-chip__busket {
  height: 100%;
  --icon-color: #1e1e1c;
  height: 30px;
  width: 30px;
}
.order-chip__quantity {
  position: absolute;
  top: -8px;
  right: -2px;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background-color: #ea4949;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-chip__quantity .number {
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/universal-page-toolbar/universal-page-toolbar.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;;AAKC;EADD;IAEE,kBAAA;EADA;AACF;;AAIA;EACC,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EAEA,qBAAA;AAFD;AAIC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAFF;AAKC;EACC,aAAA;EACA,mBAAA;AAHF;AAKE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,gBAAA;EAEA,qBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAPH;AChDE;EDoCA;IAsBE,YAAA;EANF;AACF;ACrDE;ED8DD;IAEE,iBAAA;IACA,kBAAA;EAPD;AACF;AAQE;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AANH;AASC;EACC,aAAA;EACA,mBAAA;AAPF;AAQE;EACC,iBAAA;AANH;;AAWA;EACC,iBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AARD;;AAWA;EACC,kBAAA;EAEA,gBAAA;AATD;;AAYA;EACI,WAAA;EACA,YAAA;EACH,iBAAA;EACA,UAAA;AATD;;AAYA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AATD;ACtGE;EDwGF;IAUE,aAAA;EARA;AACF;AAUC;EACC,YAAA;EAEA,qBAAA;EACA,YAAA;EACA,WAAA;AATF;AAeC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbF;AAeE;EACC,4BAAA;EACA,eAAA;EACA,WAAA;AAbH","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n}\n\napp-burger-btn {\n\t@media (height < 700px) {\n\t\tmargin-right: 10px;\n\t}\n}\n\n.wrapper {\n\tposition: relative;\n\tmin-height: 56px;\n\tbackground: var(--ion-color-tertiary);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0;\n\twidth: 100%;\n\n\t--icon-color: #1e1e1c;\n\n\t.corner {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\theight: 37px;\n\t\twidth: 49px;\n\t}\n\n\t.left_slot {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.title {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: middle;\n\t\t\ttext-align: left;\n\n\t\t\tcolor: var(--color-white);\n\t\t\twidth: var(--title-width, 180px);\n\n\t\t\tmargin-left: 9px;\n\n\t\t\tword-break: break-all;\n\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t@include desktop {\n\t\t\t\twidth: 220px;\n\t\t\t}\n\t\t}\n\t}\n\t.change-language {\n\t\t@include desktop {\n\t\t\tmargin-left: 30px;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\tion-icon {\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tborder-radius: 50%;\n\t\t\tborder: 2px solid white;\n\t\t\tmargin-right: 20px;\n\t\t}\n\t}\n\t.wrapper-icons {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n}\n\n.back-button {\n\tmargin-left: 10px;\n\tpadding: 3px;\n\theight: 24px;\n\twidth: 24px;\n}\n\n.cross-button {\n\tmargin-right: 22px;\n\n\t--ion-icon: #fff;\n}\n\n.logo {\n    width: 50px;\n    height: 50px;\n\tmargin-left: 16px;\n\tz-index: 1;\n}\n\n.order-chip {\n\tdisplay: none;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 30px;\n\tmargin-right: 12px;\n\tmargin-left: 10px;\n\tposition: relative;\n\n\t@include desktop {\n\t\tdisplay: flex;\n\t}\n\n\t&__busket {\n\t\theight: 100%;\n\n\t\t--icon-color: #1e1e1c;\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\t// @include desktop {\n\t\t// \tpointer-events:  none;\n\t\t// }\n\t}\n\n\t&__quantity {\n\t\tposition: absolute;\n\t\ttop: -8px;\n\t\tright: -2px;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tborder-radius: 50px;\n\t\tbackground-color: #ea4949;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.number {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
